import React, { useEffect, useState } from 'react';
import api from '../api';
import { useAdminLanguage } from '../AdminLanguageContext';

// 金额：数据库存分 → 展示元
const yuan = (cents) => (Number(cents || 0) / 100).toFixed(2);

export default function FinanceDashboard() {
  const { copy } = useAdminLanguage();
  const financeCopy = copy.financeDashboard;
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/admin/finance/stats')
      .then(r => setStats(r.data))
      .catch(e => setErr(e.response?.data?.error || e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>{financeCopy.loading}</div>;
  if (err) return <div style={{ padding: 40, color: '#ef4444' }}>❌ {financeCopy.errorPrefix}: {err}</div>;
  if (!stats) return null;

  const cards = [
    { icon: '💰', label: financeCopy.cards.totalBalance, value: '¥ ' + yuan(stats.totalBalance), color: '#1dbf73' },
    { icon: '🔒', label: financeCopy.cards.totalFrozen, value: '¥ ' + yuan(stats.totalFrozen), color: '#f59e0b' },
    { icon: '📥', label: financeCopy.cards.todayRecharge, value: '¥ ' + yuan(stats.todayRecharge), color: '#3b82f6' },
    { icon: '📋', label: financeCopy.cards.todayOrders, value: stats.todayOrders, color: '#8b5cf6' },
    { icon: '🔄', label: financeCopy.cards.escrowOrders, value: stats.escrowOrders, color: '#f59e0b' },
    { icon: '✅', label: financeCopy.cards.completedOrders, value: stats.completedOrders, color: '#1dbf73' },
    { icon: '↩️', label: financeCopy.cards.refundedOrders, value: stats.refundedOrders, color: '#ef4444' },
    { icon: '💸', label: financeCopy.cards.pendingWithdrawals, value: stats.pendingWithdrawals + ` ${financeCopy.requestUnit} / ¥` + yuan(stats.pendingWithdrawalsAmount), color: '#ff6f00' },
    { icon: '🧾', label: financeCopy.cards.pendingCheckoutRequests, value: stats.pendingCheckoutRequests + ` ${financeCopy.requestUnit} / ¥` + yuan(stats.pendingCheckoutAmount), color: '#6366f1' },
  ];

  return (
    <div>
      <div className="page-title">💰 {financeCopy.title}</div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        {cards.map(c => (
          <div className="card stat-card" key={c.label} style={{ borderTop: `3px solid ${c.color}` }}>
            <div style={{ fontSize: 28, marginBottom: 6 }}>{c.icon}</div>
            <div className="stat-value" style={{ color: c.color, fontSize: 20 }}>{c.value}</div>
            <div className="stat-label">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ margin: '0 0 14px', fontSize: 15 }}>📊 {financeCopy.trends.recharge14d}</h3>
        {renderBarChart(stats.rechargeTrend, '#3b82f6', v => '¥' + yuan(v), financeCopy.empty)}
      </div>

      <div className="card">
        <h3 style={{ margin: '0 0 14px', fontSize: 15 }}>📈 {financeCopy.trends.orders14d}</h3>
        {renderBarChart(stats.orderTrend, '#1dbf73', v => `${v} ${financeCopy.orderUnit(v)}`, financeCopy.empty, 'cnt')}
      </div>
    </div>
  );
}

function renderBarChart(data, color, fmt, emptyLabel, field = 'amt') {
  if (!data || data.length === 0) return <div style={{ color: '#9ca3af', padding: 20 }}>{emptyLabel}</div>;
  const max = Math.max(...data.map(d => Number(d[field] || 0)), 1);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 140, padding: '0 4px' }}>
      {data.map((d, i) => {
        const h = Math.max(4, (Number(d[field] || 0) / max) * 120);
        return (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
            <div title={fmt(d[field])} style={{ width: '100%', height: h, background: color, borderRadius: '4px 4px 0 0', opacity: 0.85 }} />
            <div style={{ fontSize: 10, color: '#9ca3af' }}>{String(d.day).slice(5)}</div>
          </div>
        );
      })}
    </div>
  );
}
